import { Alert, App, Button, Card, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { portalApi } from "../api/portal";
import { errorMessage } from "../api/client";
import { usePortalStore } from "./store";

/** C06: the temporary password is replaced on the first login; the secret never shows up in any journal. */
export function PortalPasswordPage() {
  const { message } = App.useApp();
  const me = usePortalStore((s) => s.me);
  const loadMe = usePortalStore((s) => s.loadMe);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  return (
    <Card title="Смена пароля" style={{ maxWidth: 520 }}>
      {me?.must_change_password && <Alert type="warning" showIcon message="Задайте свой пароль" description="Вы вошли по временному паролю, выданному складом. Пароль хранится только в защищённом виде и не показывается повторно." style={{ marginBottom: 16 }} />}
      <Form
        form={form}
        layout="vertical"
        onFinish={async (values: { current_password: string; new_password: string }) => {
          try {
            await portalApi.post("/auth/change-password", values);
            message.success("Пароль изменён");
            await loadMe();
            navigate("/portal", { replace: true });
          } catch (e) {
            message.error(errorMessage(e));
          }
        }}
      >
        <Form.Item name="current_password" label={me?.must_change_password ? "Текущий (временный) пароль" : "Текущий пароль"} rules={[{ required: true, message: "Введите текущий пароль" }]}>
          <Input.Password autoComplete="current-password" data-testid="portal-current-password" />
        </Form.Item>
        <Form.Item name="new_password" label="Новый пароль" extra="Не короче 8 символов, хотя бы одна цифра" rules={[{ required: true, message: "Введите новый пароль" }]}>
          <Input.Password autoComplete="new-password" data-testid="portal-new-password" />
        </Form.Item>
        <Form.Item name="confirm" label="Повторите пароль" dependencies={["new_password"]} rules={[{ required: true, message: "Повторите пароль" }, ({ getFieldValue }) => ({ validator: (_, v) => (!v || v === getFieldValue("new_password") ? Promise.resolve() : Promise.reject(new Error("Пароли не совпадают"))) })]}>
          <Input.Password autoComplete="new-password" data-testid="portal-new-password-repeat" />
        </Form.Item>
        <Button type="primary" htmlType="submit" data-testid="portal-change-password">
          Сохранить пароль
        </Button>
      </Form>
    </Card>
  );
}
